import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { RowsContainer, ShareIcon, SingleRowButtonWithIcon, } from '@streamr/tv-ui';
import { executeSoon } from '@streamr/tv-utils';
import { format } from 'date-fns';
import styled from 'styled-components';
import { useShare } from '../../../hooks/useShare';
import { BottomRight, Popup } from '../../../utils/popups';
import { AbstractPopup, DismissalReason, } from '../AbstractPopup';
import { ScrollablePopupContainer } from '../helpers/ScrollablePopupContainer';
import { PopupCssPreset } from '../Popup.styles';
const RecordingOptionsPopup = ({ reject, variant, recording, onDelete, ...props }) => {
    const { canShare, openSystemShareDialog } = useShare();
    return (_jsx(RecordingOptionsPopupRoot, { reject: reject, ...props, translateFn: BottomRight, children: _jsx(ScrollablePopupContainer, { fullscreenOnly: variant === 'mobile', onCloseButtonClick: () => {
                reject(DismissalReason.CloseButton);
            }, children: _jsxs(RowsContainer, { children: [_jsx("p", { children: format(new Date(recording.timestamp), 'MMM do yyyy') }), canShare && (_jsx(SingleRowButtonWithIcon, { label: "Share", icon: _jsx(ShareIcon, {}), onClick: () => {
                            openSystemShareDialog(recording.url, {
                                text: 'Check out the recording of my live stream!',
                            });
                        } }))] }) }) }));
};
const RecordingOptionsPopupRoot = styled(AbstractPopup) `
    ${PopupCssPreset.Fullscreen};
    // --Popup_Padding: 0;
    --Popup_Padding: 1.5rem;

    @media (min-width: 30rem) {
            ${PopupCssPreset.AnchoredBottomRight};
            --Popup_Height: auto;
            --Popup_Width: 25rem;
            --Popup_Padding: 1rem 0;
            --Popup_BorderRadius: var(--tv-ui-border-radius-2);

            /* Bring back offset transitions */
            --Popup_OffsetTransition: initial;
        }
`;
const recordingOptionsPopup = Popup.create(RecordingOptionsPopup);
export function showRecordingOptionsPopup({ anchorRef, variant, recording, onBeforeOpen, onDismiss, onDelete, }) {
    executeSoon(async () => {
        onBeforeOpen?.();
        try {
            await recordingOptionsPopup.pop({
                anchorRef,
                variant,
                recording,
                onDelete,
            });
        }
        catch (_) {
        }
        finally {
            onDismiss?.();
        }
    });
}
